import { Inject, Injectable, InjectionToken, OnDestroy } from '@angular/core';
import { EMPTY, Observable, ReplaySubject, of } from 'rxjs';
import { distinctUntilChanged, mergeMap } from 'rxjs/operators';
import { initialize, LDClient } from 'launchdarkly-js-client-sdk';
import { FeatureFlagService } from '../../services/feature-flags.service';
import Env from '@ridango/core/env';

export const LAUNCHDARKLY_CLIENT_ID = new InjectionToken<string>('launchdarkly-client-id');

@Injectable({
    providedIn: 'root'
})
export class LaunchDarklyService implements FeatureFlagService, OnDestroy {
    private client: LDClient;
    private flagChange: ReplaySubject<boolean> = new ReplaySubject(1);

    constructor(
        @Inject(LAUNCHDARKLY_CLIENT_ID) private client_id: string,
        @Inject('ENV') private env: Env
    ) {
        this.client = initialize(client_id, { key: 'anonymoususer', anonymous: true });
        this.client.on('ready', () => this.flagChange.next(true));
        this.client.on('change', () => this.flagChange.next(true));
    }

    ngOnDestroy(): void {
        this.client.off('ready', () => null);
        this.client.off('change', () => null);
        this.client.close();
    }

    getFlags(flags: string[]): Observable<any> {
        return this.flagChange.pipe(
            mergeMap(() => {
                for (const flag of flags) {
                    if (this.env.ALLOWED_FEATURE_FLAGS?.includes(flag)) {
                        return of(this.client.variation(flag));
                    }
                }
                return EMPTY;
            }),
            distinctUntilChanged()
        );
    }
}
